import { BigNumber, providers } from "ethers";
import {
  Multicall,
  ContractCallContext,
} from 'ethereum-multicall';

export async function fetchVaultsBalance(provider: providers.JsonRpcProvider, contractCallContext: Array<ContractCallContext>) {
  const multicall = new Multicall({ ethersProvider: provider, tryAggregate: true });
  try {
    const { results } = await multicall.call(contractCallContext)
    return Object.keys(results).map(key => {
      const balance = BigNumber.from(results[key].callsReturnContext[0].returnValues[0]);
      return {
        address: key,
        balance: balance,
      };
    })
  } catch (e) {
    throw e;
  }
}